export default {
  productsByCategory(state) {
    if (!state.products) return {}
    return state.products.reduce((groups, product) => {
      const type = product.category ? product.category.type : 'Sonstige'
      if (!groups[type]) {
        groups[type] = []
      }
      groups[type].push(product)
      return groups
    }, {})
  },
  uniqueSauces(state) {
    if (!state.products) return []
    const sauceMap = {}
    state.products.forEach(product => {
      if (!product.sauces) return
      product.sauces.forEach(sauce => {
        if (!sauceMap[sauce.name]) {
          sauceMap[sauce.name] = sauce.price
        }
      })
    })
    return Object.entries(sauceMap).map(([name, price]) => ({ name, price }))
  },
}
